<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <div class="row">
      <div class="col-md-4 col-lg-3" *ngFor="let reward of rewards">
        <div class="subjects-card">
          <div class="card" [ngClass]="{'new-gift':reward.redeemed === false}">
            <div
              class="card-body px-1"
              (click)="reward.isCollapsed = !reward.isCollapsed"
            >
              <div
                class="d-flex align-items-center justify-content-between card-title mb-0"
              >
                <div class="d-flex align-items-center">
                  <div *ngIf="reward.new === true">
                    <img
                      src="../../../../../assets/img/icons8-new.gif"
                      alt=""
                    />
                  </div>
                  <h4 class="mb-0 ml-1">
                    {{ reward.gift }}
                  </h4>
                </div>
                <div *ngIf="reward.isCollapsed">
                  <span [data-feather]="'chevron-up'"></span>
                </div>
                <div *ngIf="!reward.isCollapsed">
                  <span [data-feather]="'chevron-down'"></span>
                </div>
              </div>
            </div>
            <div #collapse="ngbCollapse" [ngbCollapse]="!reward.isCollapsed" (ngbCollapseChange)="reward.isCollapsed = !$event">
              <div class="card-body pt-0">
                <h6 class="mb-0">{{ reward.message }}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
